<button axButton filled color="danger" class="button" (click)="reset()">
  <ax-icon name="arrow-u-left-top" class="icon"></ax-icon>
  <span>{{ 'label.discard' | translate }}</span>
</button>
<button axButton filled color="primary" class="button" (click)="save()">
  <ax-icon name="content-save-outline" class="icon"></ax-icon>
  <span>{{ 'label.save' | translate }}</span>
</button>
